export const UUID_REGEX = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[1-5][0-9a-f]{3}-?[89ab][0-9a-f]{3}-?[0-9a-f]{12}$/i;

export function isUuid(value: unknown): value is string {
  return typeof value === 'string' && UUID_REGEX.test(value);
}

export function getUuidCandidate(item: { id?: unknown; uuid?: unknown } | null | undefined): string | null {
  if (!item) return null;
  if (isUuid(item.id)) return item.id;
  if (isUuid(item.uuid)) return item.uuid;
  return null;
}

export function nullableUuid(value: unknown): string | null {
  return isUuid(value) ? value : null;
}
